import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_2 = { style: {"margin":"0"} }
const _hoisted_3 = { style: {"padding-left":".6rem","padding-right":".4rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_loading_component = _resolveComponent("button-loading-component")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_timeline_component = _resolveComponent("timeline-component")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_button_loading_component, {
      label: "График ресурсов",
      loading: _ctx.asyncOperationPending,
      onClick: _ctx.onShowTimelineModalClick
    }, null, 8, ["loading", "onClick"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.timelineModalVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.timelineModalVisible) = $event)),
      onClosed: _ctx.onTimelineModalCloseClick,
      width: "1200",
      height: "1200"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_2, [
              _createTextVNode("Заказ-наряд "),
              _createElementVNode("span", null, _toDisplayString(_ctx.order.number), 1),
              _createTextVNode(" от " + _toDisplayString(_ctx.formatDate()), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_link, {
              onClick: _ctx.onGoPrevDateClick,
              type: "primary",
              underline: false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { size: "28" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowLeft)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_link, {
              onClick: _ctx.onGoNextDateClick,
              type: "primary",
              underline: false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { size: "28" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowRight)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_timeline_component, {
          "schedule-date": _ctx.date,
          schedule: _ctx.timelineSchedule,
          branch: _ctx.order.executiveEntityBranch!.id,
          visible: _ctx.timelineComponentVisible,
          onItemUpdated: _ctx.onTimelineItemUpdated
        }, null, 8, ["schedule-date", "schedule", "branch", "visible", "onItemUpdated"])
      ]),
      _: 1
    }, 8, ["modelValue", "onClosed"])
  ], 64))
}